import React from "react";
import { useLang } from "../context/LanguageContext";

// dark text on light bars, light text on dark bars
const textOn = (hex) => {
  try {
    const c = hex.replace("#", "");
    const r = parseInt(c.substr(0, 2), 16), g = parseInt(c.substr(2, 2), 16), b = parseInt(c.substr(4, 2), 16);
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return lum > 0.62 ? "#2A2620" : "#FBF7F0";
  } catch { return "#2A2620"; }
};

export const MainAccords = ({ accords }) => {
  const { t, lang } = useLang();
  const rows = (accords || [])
    .filter((a) => (a.name_en || a.name_ar) && Number(a.pct) > 0)
    .sort((a, b) => Number(b.pct) - Number(a.pct));
  if (rows.length === 0) return null;
  const max = Math.max(...rows.map((r) => Number(r.pct)));

  return (
    <div className="mt-8" data-testid="main-accords">
      <p className="text-[10px] uppercase tracking-[0.3em] text-[#C49A6C] mb-4">{t("main_accords")}</p>
      <div className="space-y-1.5">
        {rows.map((a, i) => {
          const w = Math.max(22, (Number(a.pct) / max) * 100);
          const name = lang === "ar" ? (a.name_ar || a.name_en) : (a.name_en || a.name_ar);
          return (
            <div key={`${a.name_en || a.name_ar}-${a.color}`} className="w-full" data-testid={`accord-bar-${i}`}>
              <div
                className="h-9 flex items-center justify-end rounded-e-full transition-all duration-500"
                style={{ width: `${w}%`, backgroundColor: a.color || "#C49A6C" }}
              >
                <span
                  className="text-sm font-medium pe-5 truncate"
                  style={{ color: textOn(a.color || "#C49A6C") }}
                >
                  {name}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
